import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EditService } from './edit.service';
import { Injectable } from '@angular/core';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class InsuranceProvidersService extends EditService<any, any> {
  url = '/api/insuranceproviders';
  entityTitle = 'Insurance Provider';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public save(item: any): Promise<any> {
    return this.handleRequest(
      this.http.post(`${this.url}`, item),
      this.handlersFactory.getForCreate(this.entityTitle),
    ).then(this.extractData);
  }

  public deleteItem(item: any): Promise<any> {
    return this.http.post(`${this.url}/deleteItem`, item).toPromise();
  }

  public getProvidersByJobId(jobId: number): Promise<any[]> {
    return this.http.get<any[]>(`${this.url}/providersByJobId/${jobId}`).toPromise();
  }
}
